// @flow
import { handleActions } from "redux-actions";
import { setupRequest } from "./request.reducer";
import {
    closeFeedbackDialog,
    openFeedbackDialog,
    submitFeedback,
    submitFeedbackFailure,
    submitFeedbackSuccess
} from "../actions/feedback.actions";
import { RequestState } from "../records/request.record";
import Record from "../flow/Record";

export class Feedback extends Record({
    request: new RequestState(),
    open: false,
    success: false
}) {
    request: RequestState;
    open: boolean;
    success: boolean;
}

const request = setupRequest("request");

const feedback = handleActions(
    {
        [submitFeedback]: request.start,
        [submitFeedbackSuccess](state) {
            return request.success(state).set("success", true);
        },
        [submitFeedbackFailure]: request.failure,
        [openFeedbackDialog](state) {
            return state.merge({
                success: false,
                open: true
            });
        },
        [closeFeedbackDialog](state) {
            return state.merge({
                open: false
            });
        }
    },
    new Feedback()
);

export default feedback;



// WEBPACK FOOTER //
// ./src/reducers/feedback.reducer.js